export default "__VITE_ASSET__Cvl1P_0h__"